import { Controller } from "@hotwired/stimulus"

// Keeps the API reference sidebar visually still across Turbo Drive visits.
// Turbo replaces <body> on every navigation, so the restored element always
// starts at scrollTop 0 and the position has to be re-applied by hand.
export default class extends Controller {
  static values = { key: { type: String, default: "api-ref-sidebar-scroll" } }

  connect() {
    this.restore()
    this.save = this.save.bind(this)
    this.element.addEventListener("scroll", this.save, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.save)
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  restore() {
    const saved = sessionStorage.getItem(this.keyValue)
    if (saved === null) {
      this.revealActiveLink()
      return
    }

    this.element.scrollTop = parseInt(saved, 10)

    // If the active link isn't visible at the restored offset, the visitor
    // arrived from somewhere other than this sidebar — centre it instead.
    if (!this.activeLinkVisible()) this.revealActiveLink()
  }

  save() {
    if (this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = null
      sessionStorage.setItem(this.keyValue, this.element.scrollTop)
    })
  }

  get activeLink() {
    return this.element.querySelector("[aria-current='page']")
  }

  activeLinkVisible() {
    const link = this.activeLink
    if (!link) return true

    const container = this.element.getBoundingClientRect()
    const target = link.getBoundingClientRect()
    return target.top >= container.top && target.bottom <= container.bottom
  }

  revealActiveLink() {
    const link = this.activeLink
    if (!link) return

    this.element.scrollTop =
      link.offsetTop - this.element.clientHeight / 2 + link.offsetHeight / 2
    this.save()
  }
}
